<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-10 13:47:54
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-26 19:23:11
 * @FilePath: \hzs-nutra-wecom-shop\src\views\customer\customerDetail.vue
 * @Description: 我的客户 - 客户详情
-->

<template>
  <div class="page-container">
    <div class="mainContent">
      <div class="userInfo">
        <div class="up flex align-center justify-sb">
          <div class="leftBox flex align-center">
            <img
              :src="userInfo?.user_base_info?.avatar_url || EmptyHeadImg"
              class="img"
              alt=""
            />

            <div class="msg">
              <div class="name">{{ userInfo?.user_base_info?.name }}</div>
              <div class="gOrA">
                {{ getGender(userInfo?.user_base_info?.sex) }}
                {{ getAge(userInfo?.user_base_info?.birthday) }}岁
              </div>
            </div>
          </div>

          <div class="iconBox flex align-center">
            <template v-if="userInfo?.user_base_info?.openid">
              <i class="icon db wechatIcon"></i>
            </template>
            <template v-if="userInfo?.user_we_com_info">
              <i class="icon db weComIcon"></i>
            </template>
          </div>
        </div>

        <div class="shopClerkMsg">
          <p>
            已添加员工：{{ userInfo?.user_we_com_info?.follower_user_names }}
          </p>
          <p>
            首次添加：{{
              userInfo?.user_we_com_info?.first_follow_time
                ? dayjs(userInfo?.user_we_com_info?.first_follow_time).format(
                    "YYYY-MM-DD HH:mm:ss",
                  )
                : ""
            }}
          </p>
        </div>

        <van-divider />

        <ul class="statisticsBox flex justify-sb align-center">
          <li
            @click="
              router.push({
                path: '/orderlist',
                query: { user_uuid: userInfo?.user_base_info?.user_uuid },
              })
            "
          >
            <p class="num">
              {{ userInfo?.user_summary_info?.total_amount / 100 }}
            </p>
            <div class="df align-center">
              <span>累计消费</span>
              <i class="db icon arrowLeftSingleIcon"></i>
            </div>
          </li>
          <li class="separator"></li>
          <li>
            <p class="num">{{ userInfo?.user_summary_info?.coupon_count }}</p>
            <div class="df align-center">
              <span>优惠券</span>
              <i class="db icon arrowLeftSingleIcon"></i>
            </div>
          </li>
          <li class="separator"></li>
          <li @click="handelGotoPointBill">
            <p class="num">{{ userInfo?.user_summary_info?.current_point }}</p>
            <div class="df align-center">
              <span>积分</span>
              <i class="db icon arrowLeftSingleIcon"></i>
            </div>
          </li>
        </ul>
      </div>

      <div class="shopMsg">
        <div class="msgItem">
          <div class="msg h100">
            <span>企微备注名：</span
            ><span>{{ userInfo?.user_we_com_info?.follow_remark }}</span>
          </div>

          <i
            v-if="type === 'mini'"
            class="icon db editIcon"
            @click="
              router.push({
                path: '/createCustomer',
                query: {
                  user_uuid: userInfo?.user_base_info?.user_uuid,
                  returnBack: '/customerDetail',
                  returnBackQuery: JSON.stringify({
                    type,
                  }),
                },
              })
            "
          ></i>
        </div>
        <div class="msgItem">
          <div class="msg">
            <span>备注手机号：</span
            ><span>{{ userInfo?.user_base_info?.phone }}</span>
          </div>
        </div>
        <div class="msgItem">
          <div class="msg">
            <span>真实姓名：</span
            ><span>{{ userInfo?.user_base_info?.name }}</span>
          </div>
        </div>
        <div v-if="userInfo?.user_shop_info" class="msgItem">
          <div class="msg">
            <span>归属门店：</span
            ><span>{{ userInfo?.user_shop_info?.shop_name }}</span>
          </div>

          <p @click="handleRemoveMe">门店移除</p>
        </div>
        <div class="msgItem">
          <div class="msg">
            <span>负责人：</span
            ><span>{{ userInfo?.user_shop_clerk_info?.shop_clerk_name }}</span>
          </div>

          <p v-if="type === 'mini'" @click="handleChangeManager">
            更换负责任人
          </p>
        </div>
        <div class="msgItem">
          <div class="msg">
            <span>注册时间：</span
            ><span>{{ userInfo?.user_base_info?.created_at }}</span>
          </div>
        </div>
        <div class="msgItem">
          <div class="msg">
            <span>联系方式：</span
            ><span>{{ userInfo?.user_base_info?.phone }}</span>
          </div>
        </div>
        <div class="msgItem">
          <div class="msg">
            <span>地址：</span
            ><span>{{ userInfo?.user_base_info?.address }}</span>
          </div>
        </div>
        <div class="msgItem">
          <div class="msg">
            <span>生日：</span
            ><span>{{
              userInfo?.user_base_info?.birthday &&
              dayjs(userInfo?.user_base_info?.birthday).format("YYYY-MM-DD")
            }}</span>
          </div>
        </div>
        <div class="msgItem">
          <div class="msg flex1">
            <span>标签：</span
            ><span>{{ userInfo?.user_tag_info?.tag_names }}</span>
          </div>

          <p @click="handleChangeTags">修改标签</p>
        </div>
        <div class="msgItem">
          <div class="msg">
            <span>备注：</span
            ><span>{{ userInfo?.user_base_info?.remark }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom_button_box">
      <van-button
        round
        block
        type="primary"
        color="#DCBB89"
        plain
        class="save-btn"
        @click="router.push({ path: '/orderlist', query: { user_uuid } })"
      >
        查看客户订单
      </van-button>

      <van-button
        round
        block
        type="primary"
        color="#DCBB89"
        class="save-btn"
        @click="
          router.push({
            path: 'takeOrderType',
            query: { user_uuid },
          })
        "
      >
        代客下单
      </van-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import dayjs from "dayjs";
import { ref, reactive, computed, onMounted, onBeforeUnmount } from "vue";
import { useRouter, useRoute } from "vue-router";
import CustomerApi from "@/utils/api/customer";
import EmptyHeadImg from "@/assets/img/icons/emptyHeadImg.png";
import { showConfirmDialog, showFailToast, showSuccessToast } from "vant";

// --------------------------------------- 变量
const router = useRouter();
const route = useRoute();
const { user_uuid, type, unionid } = route.query;
const state = reactive({
  statistics: {
    spendNum: 0,
    couponNum: 0,
    pointNum: 0,
  },
});
const userInfo = ref({});

// --------------------------------------- 方法、事件
onMounted(async () => {
  GroupService.getInfo();
});

const getGender = (gender: number | string) =>
  ({
    1: "男",
    2: "女",
    3: "",
  })[gender] || "";
function getAge(birthday) {
  return dayjs().diff(dayjs(birthday), "year");
}

// 修改标签
function handleChangeTags() {
  router.push({
    path: "/customerTagsEdit",
    query: {
      user_uuid,
    },
  });
}

// 跳转积分账单
function handelGotoPointBill() {
  router.push({ path: "/pointBill", query: { user_uuid } });
}

// 跳转 更换负责人
function handleChangeManager() {
  router.push({ path: "/transformCustomer", query: { user_uuid } });
}

// 执行门店移除
function handleRemoveMe() {
  showConfirmDialog({
    title: "提示",
    message: `是否确认从当前门店移除员工：${userInfo.value?.user_base_info?.name}？`,
    confirmButtonColor: "#DCBB89",
    cancelButtonColor: "#999999",
    width: "90%",
  })
    .then(() => {
      CustomerApi._customerRemoveClerk({
        shop_uuid: userInfo.value?.user_shop_info?.shop_uuid,
        user_uuid,
      }).then((res) => {
        console.log(res);
        if (res?.code === 200) {
          showSuccessToast("移除成功！");
          router.go(-1);
        } else {
          showFailToast("移除失败！");
        }
      });
    })
    .catch((err) => {
      console.log(err);
    });
}

// --------------------------------------- 请求
const GroupService = {
  async getInfo() {
    let res = null;
    if (type == "mini") {
      res = await CustomerApi._customerInfo({ user_uuid, unionid }).catch(
        (err) => {},
      );
    } else if (type == "qw") {
      res = await CustomerApi._customerInfo2({ user_uuid, unionid }).catch(
        (err) => {},
      );
    }

    userInfo.value = res?.data || {};
  },
};
</script>

<style lang="scss" scoped>
/* @use 'xxx.scss' as *; */
/*
    .page-container
        ---- 主体内容
        .mainContent

        ---- 底部操作栏
        .bottom_button_box
    @supports

    **** 在 @/scss/common.scss ****
*/

.mainContent {
  overflow-y: auto;
}
.icon {
  width: 28px;
  height: 28px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  &.wechatIcon {
    background-image: url("@/assets/img/icons/wechat-ico.png");
  }
  &.weComIcon {
    background-image: url("@/assets/img/icons/wecom-ico.png");
  }
  &.telephoneIcon {
    background-image: url("@/assets/img/icons/phoneicon-1.png");
  }
  &.arrowLeftSingleIcon {
    width: 14px;
    height: 14px;
    background-image: url("@/assets/img/icons/arrowLeftSingle.png");
  }
  &.editIcon {
    width: 24px;
    height: 24px;
    background-image: url("@/assets/img/icons/edit.png");
  }
}

.userInfo {
  padding: 12px 6px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;

  .up {
    padding: 0 10px;

    .leftBox {
      .img {
        width: 42px;
        height: 42px;
        border-radius: 100%;

        margin-right: 11px;
      }

      .name {
        height: 25px;
        line-height: 25px;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      .gOrA {
        height: 20px;
        line-height: 20px;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
    .iconBox {
      min-width: 28px;
      height: 28px;
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #ff7123;
      text-align: right;
      font-style: normal;
      text-transform: none;

      i:first-child {
        margin-right: 10px;
      }
    }
  }

  .shopClerkMsg {
    margin-top: 8px;
    padding: 0 10px;

    p:first-child {
      margin-bottom: 4px;
    }
    p {
      height: 20px;
      line-height: 20px;
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }

  .statisticsBox {
    padding: 0 11px 4px;

    li {
      &.separator {
        width: 0px;
        height: 30px;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #f5f5f5;
      }

      .num {
        height: 25px;
        line-height: 25px;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #333333;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .num + div {
        height: 22px;
        line-height: 22px;

        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }
}

.shopMsg {
  padding: 14px 16px;
  margin-top: 10px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;

  .msgItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 24px;
    line-height: 24px;

    &:not(:first-child) {
      margin-top: 16px;
    }

    .msg {
      span {
        height: 22px;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 400;
        font-size: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      span:first-child {
        color: #666666;
      }
      span:last-child {
        color: #333;
      }
    }

    p {
      min-height: 22px;
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #ff7123;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
}
</style>
